<template>
  <section>
    <fab :actions="fabActions"
      :bg-color="bgColor"
       @portfolio="portfolio"
       @blog="blog"
       @home="home"
       main-icon="reorder"
  ></fab>
  </section>
</template>

<script>
import fab from 'vue-fab'
import router from '../router'

export default {
  name: 'Menu',
  components: {
    fab
  },
   data(){
      return {
          bgColor: '#401b85',
          position: 'top-right',
          fabActions: [

              {
                  name: 'portfolio',
                //   tooltip : "Portfolio",
                  icon: 'work'
              },
              {
                  name: 'blog',
                //   tooltip : "Blog",
                  icon: 'library_books'
              },
              {
                  name: 'home',
                //   tooltip : "Home",
                  icon: 'home'
              },
          ]
      }
  },
  methods:{
      portfolio(){
          router.push('/portfolio')
      },
      home(){
          router.push('/')
      },
      blog(){
          router.push('/blog')
      }
  }
}
</script>

<style lang="scss">
// @import url(../../node_modules/mfb/src/mfb.scss);
</style>



// WEBPACK FOOTER //
// src/componests/Menu.vue